import { extras, store } from "@/mocks/store";

export interface MockResponse {
  status: number;
  body: unknown;
}

export function ok<T>(data: T, status = 200): MockResponse {
  return { status, body: data };
}

export function err(status: number, code: string, message: string): MockResponse {
  return { status, body: { code, message } };
}

export function paginate<T>(items: T[], query: URLSearchParams) {
  const page = Math.max(1, Number(query.get("page") || 1));
  const pageSize = Math.min(100, Math.max(1, Number(query.get("pageSize") || 20)));
  const start = (page - 1) * pageSize;
  return {
    data: items.slice(start, start + pageSize),
    meta: { total: items.length, page, pageSize },
  };
}

export function matchPath(pattern: string, path: string): Record<string, string> | null {
  const pp = pattern.split("/").filter(Boolean);
  const sp = path.split("/").filter(Boolean);
  if (pp.length !== sp.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < pp.length; i++) {
    if (pp[i].startsWith(":")) params[pp[i].slice(1)] = decodeURIComponent(sp[i]);
    else if (pp[i] !== sp[i]) return null;
  }
  return params;
}

export function nowStamp() {
  return new Date().toISOString().slice(0, 16).replace("T", " ");
}

export function pushAudit(action: string, target: string, detail: string, user?: string) {
  store.AUDIT_LOGS.unshift({
    time: nowStamp(),
    user: user || store.ROLES[store.SESSION.currentRole]?.user || "system",
    action,
    target,
    detail,
  });
}

export function genRippleId() {
  for (let i = 0; i < 20; i++) {
    const id = `p_${Math.random().toString(36).slice(2, 14)}`;
    if (!store.PACKAGES.some((p) => p.id === id)) return id;
  }
  return `p_${Date.now().toString(36)}`;
}
